import PageHero from '../components/PageHero';
import Reveal from '../components/Reveal';

const stats = [
  ['5', 'Rounds'],
  ['100+', 'Junior players'],
  ['2', 'Titles — team & individual'],
  ['#4', 'World ranking — special guest'],
];

const schedule = [
  { time: '9:30am', cls: '', body: 'Registration & arrival. Michael Adams welcomed. Chess at Sea SenseRobot available for play.' },
  { time: '9:45am', cls: 'round', tag: 'Round 1', body: 'Swiss-system — team & individual competitions running simultaneously' },
  { time: '10:15am', cls: 'round', tag: 'Round 2', body: 'Swiss-system' },
  { time: '10:45am', cls: 'highlight', tag: 'Special Event', strong: 'Break & Simultaneous Exhibition', body: ' — Michael Adams plays multiple children simultaneously in the traditional grandmaster format. Limited places, sign-up in advance.' },
  { time: '11:05am', cls: 'round', tag: 'Round 3', body: 'Swiss-system' },
  { time: '11:40am', cls: 'round', tag: 'Round 4', body: 'Swiss-system' },
  { time: '12:15pm', cls: '', body: 'Lunch' },
  { time: '12:45pm', cls: 'highlight', tag: 'Special Event', strong: 'Q&A with Michael Adams', body: ' — children’s pre-submitted questions put to Michael Adams, hosted by Robert Palser. Open floor questions to follow. Approximately 25–30 minutes.' },
  { time: '1:15pm', cls: 'highlight', tag: 'Special Event — Media Moment', strong: 'SenseRobot vs Michael Adams', body: ' — live exhibition game. England’s greatest chess player takes on the world’s most advanced AI chess robot. Commentated for the audience. Approximately 20–25 moves.' },
  { time: '1:50pm', cls: 'round', tag: 'Round 5', body: 'Swiss-system — final round' },
  { time: '2:25pm', cls: '', body: 'Results collation. Playoff if required. Adjudication of unfinished games.' },
  { time: '3:05pm', cls: 'highlight', tag: 'Finale', strong: 'Prize Giving', body: ' — Michael Adams presents team and individual trophies, medals, and certificates. Chess at Sea awards.' },
  { time: '3:35pm', cls: '', body: 'Close' },
];

const moments = [
  ['10:45am', 'Grandmaster Simultaneous Exhibition', 'Michael Adams moves from board to board, playing multiple children simultaneously. Every child who participates can say they played England’s greatest chess player. A memory that lasts a lifetime.'],
  ['12:45pm', 'Q&A with Michael Adams', 'Children’s questions — submitted by schools in advance — put to Michael Adams over the lunch break. Hosted by Robert Palser. Warm, accessible, and genuinely entertaining for all ages.'],
  ['1:15pm', 'SenseRobot vs Michael Adams', 'The centrepiece of the day. A grandmaster playing an AI robot that physically moves its own pieces — in front of 100+ children. This is the visual the cameras want. The game begins at 1:15pm sharp.'],
];

const adamsStats = [
  ['Peak world ranking', 'Number 4'],
  ['Title achieved', 'Age 17'],
  ['Nationality', 'English (Cornwall)'],
  ['Present at', 'All day, 3rd July'],
];

const adamsDay = [
  ['9:30am', 'Welcomed and introduced at the tournament opening'],
  ['10:45am', 'Simultaneous exhibition — plays multiple children at once'],
  ['12:45pm', 'Q&A session — children’s questions, open floor'],
  ['1:15pm', 'Live exhibition game vs SenseRobot AI chess robot'],
  ['3:05pm', 'Presents team and individual trophies and prizes'],
];

const media = [
  ['Broadcast', 'BBC Wales Today', 'Human interest, schools chess, grandmaster. The SenseRobot vs MA game is the visual.', 'walesnewsonline@bbc.co.uk'],
  ['National Wales', 'Western Mail', 'Wales’s national newspaper. Contact the editor directly for this story.', 'alan.edmunds@reachplc.com'],
  ['Local', 'Merthyr Tydfil Times', 'The most direct local outlet for this event.', 'editor@merthyr-tydfil.com'],
  ['Chess Media', 'ChessBase', 'The world’s largest chess news website. Michael Adams appearing anywhere is news to their global audience.', 'feedback@chessbase.com'],
  ['Chess Federation', 'English Chess Federation', 'ECF news and communications team.', 'info@englishchess.org.uk'],
  ['Media Contact', 'Robert Palser', 'Chess at Sea — for all media enquiries, accreditation, and photography access.', 'robertpalser@outlook.com'],
];

export default function Events() {
  return (
    <>
      <PageHero
        tag="Events"
        title={<>Chess at Sea <em>in action</em></>}
        lede="From grassroots schools tournaments to AI robot exhibition matches — Chess at Sea brings chess to life wherever people gather."
      />

      <section className="main-event">
        <div className="inner">
          <Reveal>
            <p className="section-tag">Headline Event 2026</p>
            <h2 className="section-title">The Great Merthyr Schools <em>Chess Tournament</em></h2>
            <div className="divider" />
          </Reveal>

          <Reveal className="event-hero">
            <div className="event-date-block">
              <div className="event-day">3</div>
              <span className="event-month">July</span>
              <div className="event-year">2026</div>
            </div>
            <div className="event-title-block">
              <div className="event-subtitle">Headline Sponsor — Chess at Sea</div>
              <h2>The Great Merthyr Schools Chess Tournament 2026</h2>
              <p>
                Five rounds of Swiss-system chess for junior players from Merthyr schools — with team
                and individual titles at stake. Organised by the StephensandGeorge Charitable Trust,
                hosted at Dowlais Community Centre. Special Guest: Michael Adams, England&rsquo;s greatest
                ever chess player and former world top four.
              </p>
              <span className="sponsor-badge">Chess at Sea — Headline Sponsor</span>
            </div>
          </Reveal>

          <Reveal className="event-stats" delay={100}>
            {stats.map(([n, l]) => (
              <div className="event-stat" key={l}>
                <div className="n">{n}</div>
                <div className="l">{l}</div>
              </div>
            ))}
          </Reveal>
        </div>
      </section>

      <section className="schedule">
        <div className="inner">
          <Reveal>
            <p className="section-tag">Day Schedule</p>
            <h2 className="section-title">Friday 3rd July — <em>Full Day</em></h2>
            <div className="divider" />
          </Reveal>
          <Reveal delay={100}>
            <table className="schedule-table">
              <thead><tr><th>Time</th><th>Event</th></tr></thead>
              <tbody>
                {schedule.map((r, i) => (
                  <tr className={r.cls} key={i}>
                    <td className="time">{r.time}</td>
                    <td>
                      {r.tag && <span className="special-tag">{r.tag}</span>}
                      {r.strong ? <><strong>{r.strong}</strong>{r.body}</> : r.body}
                    </td>
                  </tr>
                ))}
              </tbody>
            </table>
          </Reveal>
        </div>
      </section>

      <section className="moments on-dark">
        <div className="inner">
          <Reveal>
            <p className="section-tag">Three Unmissable Moments</p>
            <h2 className="section-title">The moments that <em>matter</em></h2>
            <div className="divider" />
          </Reveal>
          <div className="moments-grid">
            {moments.map(([t, h, p], i) => (
              <Reveal key={h} className="moment-card" delay={i * 90}>
                <div className="moment-time">{t}</div>
                <h3>{h}</h3>
                <p>{p}</p>
              </Reveal>
            ))}
          </div>
        </div>
      </section>

      <section className="adams">
        <div className="inner">
          <Reveal>
            <p className="section-tag">Special Guest</p>
            <h2 className="section-title">Michael <em>Adams</em></h2>
            <div className="divider" />
          </Reveal>
          <div className="adams-grid">
            <Reveal className="adams-card">
              <div className="adams-name">Michael Adams</div>
              <div className="adams-title">Grandmaster</div>
              <p className="who">England&rsquo;s greatest ever chess player</p>
              <div className="adams-stats">
                {adamsStats.map(([k, v]) => (
                  <div className="adams-stat" key={k}><strong>{k}</strong><span>{v}</span></div>
                ))}
              </div>
            </Reveal>
            <Reveal className="adams-bio" delay={120}>
              <h3>About Michael Adams</h3>
              <p>
                Michael Adams is England&rsquo;s greatest ever chess player and one of the most respected
                grandmasters in the world. Born in Truro, Cornwall in 1971, he achieved the grandmaster
                title at just 17 years old and has been ranked as high as number four in the world. He
                has represented England in numerous Chess Olympiads and remains one of the elite players
                in international chess.
              </p>
              <p>
                On Friday 3rd July, Michael Adams will be with the children of Merthyr for the entire
                day — not as a distant figurehead, but as an active participant in every element of the
                programme.
              </p>
              <div className="adams-day">
                {adamsDay.map(([t, p]) => (
                  <div className="adams-activity" key={t}>
                    <span className="act-time">{t}</span><p>{p}</p>
                  </div>
                ))}
              </div>
            </Reveal>
          </div>
        </div>
      </section>

      <section className="media-section">
        <div className="inner">
          <Reveal>
            <p className="section-tag">Media</p>
            <h2 className="section-title">Press &amp; <em>media enquiries</em></h2>
            <div className="divider" />
            <p className="section-body">
              Media are welcome to attend The Great Merthyr Schools Chess Tournament 2026. Please contact
              Robert Palser in advance to arrange accreditation. The key visual moment — SenseRobot vs
              Michael Adams — begins at approximately 1:15pm.
            </p>
          </Reveal>
          <div className="media-grid">
            {media.map(([type, h, p, email], i) => (
              <Reveal key={h} className="media-card" delay={(i % 3) * 90}>
                <div className="media-type">{type}</div>
                <h4>{h}</h4>
                <p>{p}</p>
                <a href={`mailto:${email}`}>{email}</a>
              </Reveal>
            ))}
          </div>
        </div>
      </section>
    </>
  );
}
